import Wrapper from '../components/global/Wrapper';
import Aircraft from '../assets/images/dashboard-business/aircraft.svg';

const LoanBusiness = () => {
  return (
    <Wrapper className=' space-y-3 pt-[12px] md:pt-12 md:space-y-8  !mr-0'>
      <div className='mt-12'>
        <p
          style={{
            textAlign: 'center',
          }}
        >
          Coming Soon
        </p>
        <div
          style={{
            margin: '0 auto',
            marginTop: '5rem',
          }}
          className='w-[600px] imageDiv h-[400px]'
        >
          <img className='w-ful h-full' src={Aircraft} alt='air plane ' />
        </div>
      </div>
    </Wrapper>
  );
};

export default LoanBusiness;
